const multipleData = {
  '计量机构': {
    // 'active': true,
    '部门级别': [
      {
        id: '1',
        name: '国家级',
        type: 'level'
      },
      {
        id: '2',
        name: '省级',
        type: 'level'
      },
      {
        id: '3',
        name: '市级',
        type: 'level'
      }
    ],
    '行政区划': [
      {
        'code': '11',
        'id': 2,
        'name': '北京市',
        'type': 'provinceCode'
      },
      {
        'code': '31',
        'id': 10,
        'name': '上海市',
        'type': 'provinceCode'
      },
      {
        'code': '12',
        'id': 3,
        'name': '天津市',
        'type': 'provinceCode'
      },
      {
        'code': '13',
        'id': 4,
        'name': '河北省',
        'type': 'provinceCode'
      },
      {
        'code': '14',
        'id': 5,
        'name': '山西省',
        'type': 'provinceCode'
      },
      {
        'code': '15',
        'id': 6,
        'name': '内蒙古自治区',
        'type': 'provinceCode'
      },
      {
        'code': '21',
        'id': 7,
        'name': '辽宁省',
        'type': 'provinceCode'
      },
      {
        'code': '22',
        'id': 8,
        'name': '吉林省',
        'type': 'provinceCode'
      },
      {
        'code': '23',
        'id': 9,
        'name': '黑龙江省',
        'type': 'provinceCode'
      },
      {
        'code': '32',
        'id': 11,
        'name': '江苏省',
        'type': 'provinceCode'
      },
      {
        'code': '33',
        'id': 12,
        'name': '浙江省',
        'type': 'provinceCode'
      },
      {
        'code': '34',
        'id': 13,
        'name': '安徽省',
        'type': 'provinceCode'
      },
      {
        'code': '35',
        'id': 14,
        'name': '福建省',
        'type': 'provinceCode'
      },
      {
        'code': '37',
        'id': 15,
        'name': '山东省',
        'type': 'provinceCode'
      },
      {
        'code': '41',
        'id': 16,
        'name': '河南省',
        'type': 'provinceCode'
      },
      {
        'code': '42',
        'id': 17,
        'name': '湖北省',
        'type': 'provinceCode'
      },
      {
        'code': '43',
        'id': 18,
        'name': '湖南省',
        'type': 'provinceCode'
      },
      {
        'code': '44',
        'id': 19,
        'name': '广东省',
        'type': 'provinceCode'
      },
      {
        'code': '45',
        'id': 20,
        'name': '广西壮族自治区',
        'type': 'provinceCode'
      },
      {
        'code': '46',
        'id': 21,
        'name': '海南省',
        'type': 'provinceCode'
      }
    ]
  },
  '服务能力': {
    '技术能力': [

    ]
  }
  // '计量标准': {
//     '认证类别': [
//       {
//         id: '1',
//         name: '管理体系认证'
//       },
//       {
//         id: '2',
//         name: '服务认证'
//       },
//       {
//         id: '3',
//         name: '产品认证'
//       }
//     ],
//     '认证领域': [
//       {
//         id: '1',
//         name: '质量管理体系认证'
//       },
//       {
//         id: '2',
//         name: '环境管理体系认证'
//       },
//       {
//         id: '3',
//         name: '职业健康安全管理体系认证'
//       }
//     ],
//     '行政区划': [
//       {
//         id: '1',
//         name: '北京市'
//       },
//       {
//         id: '2',
//         name: '上海市'
//       },
//       {
//         id: '3',
//         name: '浙江省'
//       }
//     ]
//   },
//   '计量标准申请变更': {
//     '认证类别': [
//       {
//         id: '1',
//         name: '管理体系认证'
//       },
//       {
//         id: '2',
//         name: '服务认证'
//       },
//       {
//         id: '3',
//         name: '产品认证'
//       }
//     ],
//     '认证领域': [
//       {
//         id: '1',
//         name: '质量管理体系认证'
//       },
//       {
//         id: '2',
//         name: '环境管理体系认证'
//       },
//       {
//         id: '3',
//         name: '职业健康安全管理体系认证'
//       }
//     ],
//     '行政区划': [
//       {
//         id: '1',
//         name: '北京市'
//       },
//       {
//         id: '2',
//         name: '上海市'
//       },
//       {
//         id: '3',
//         name: '浙江省'
//       },
//       {
//         id: '4',
//         name: '辽宁省'
//       }
//     ]
//   }
}
export default multipleData



// WEBPACK FOOTER //
// ./src/layout/common/config/metroloy.js